export default __webpack_public_path__ + "static/media/usersPerfilMenuIcon.caa7a3e1.svg";